import { pushDataLayer } from '~/src/features/payments-abn/helpers/pushDataLayer';

import * as ST from './styled';

const banksData = [
    {
        id: 'sber',
        name: 'Сбер',
    },
    {
        id: 'vtb',
        name: 'ВТБ',
    },
    {
        id: 'tinkoff',
        name: 'Тинькофф',
    },
    {
        id: 'alfa',
        name: 'Альфа Банк',
    },
    {
        id: 'raiffeisen',
        name: 'Райффайзен Банк',
    },
];

const SbpInstruction = (): JSX.Element => {
    return (
        <ST.Instruction>
            <ST.InstructionItem>
                Откройте приложение вашего банка. Найдите кнопку «Оплатить по&nbsp;QR» или иконку QR-кода. Обычно их&nbsp;можно найти в&nbsp;разделе «Платежи».
                <ST.BankList>
                    {banksData.map(bank => (
                        <ST.BankItem key={bank.id}>
                            <img
                                src={`/static/images/payments-abn/banks/${bank.id}.png`}
                                alt={`Логотип ${bank.name}`}
                            />
                        </ST.BankItem>
                    ))}
                    <ST.SbpLink
                        href='https://sbp.nspk.ru/participants/'
                        onClick={() => pushDataLayer('click payment by SBP', '')}
                        target={'_blank'}
                        rel='noopener noreferrer'
                    />
                </ST.BankList>
            </ST.InstructionItem>
            <ST.InstructionItem>Нажмите на&nbsp;кнопку и&nbsp;наведите камеру смартфона на&nbsp;QR-код.</ST.InstructionItem>
            <ST.InstructionItem>Нажмите «Продолжить» и&nbsp;подтвердите платёж.</ST.InstructionItem>
        </ST.Instruction>
    );
};

export default SbpInstruction;
